import "./App.scss";
import C2PRoutes from "./C2PRoutes";

function App() {
  return <C2PRoutes lang="ENGLISH"></C2PRoutes>;
}

export default App;
